<app-top-navigation [ngStyle]="{'visibility': nav.displayTop ? 'visible' : 'hidden'}"></app-top-navigation>
<div
  class="content"
  [@routeAnimations]="prepareRoute(outlet)"
  style="position: relative;"
>
  <router-outlet #outlet="outlet"></router-outlet>
</div>